"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** @hidden */
exports.FormContext = React.createContext(null);
//# sourceMappingURL=FormContext.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-form@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-form/dist/npm/FormContext.js
// module id = 124
// module chunks = 0